// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__OTvrv","selected":"Chip_selected__zChfy"};